/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { PatchApiTracksIdStatusMutationRequest, PatchApiTracksIdStatusMutationResponse, PatchApiTracksIdStatusPathParams, PatchApiTracksIdStatus400, PatchApiTracksIdStatus401, PatchApiTracksIdStatus403, PatchApiTracksIdStatus404, PatchApiTracksIdStatus500 } from "../../types/PatchApiTracksIdStatus.ts";
import { patchApiTracksIdStatusMutationResponseSchema, patchApiTracksIdStatusMutationRequestSchema } from "../../zod/TracksSchemas/patchApiTracksIdStatusSchema.ts";

function getPatchApiTracksIdStatusUrl({ id }: { id: PatchApiTracksIdStatusPathParams["Id"] }) {
  const res = { method: 'PATCH', url: `/api/tracks/${id}/status` as const }  
  return res
}

/**
 * @summary Архивирование трека по идентификатору
 * {@link /api/tracks/:Id/status}
 */
export async function patchApiTracksIdStatus({ id, data }: { id: PatchApiTracksIdStatusPathParams["Id"]; data?: PatchApiTracksIdStatusMutationRequest }, config: Partial<RequestConfig<PatchApiTracksIdStatusMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = patchApiTracksIdStatusMutationRequestSchema.parse(data)  
  
  const res = await request<PatchApiTracksIdStatusMutationResponse, ResponseErrorConfig<PatchApiTracksIdStatus400 | PatchApiTracksIdStatus401 | PatchApiTracksIdStatus403 | PatchApiTracksIdStatus404 | PatchApiTracksIdStatus500>, PatchApiTracksIdStatusMutationRequest>({ method : "PATCH", url : getPatchApiTracksIdStatusUrl({ id }).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/*+json', ...requestConfig.headers } })  
  return patchApiTracksIdStatusMutationResponseSchema.parse(res.data)
}